export const SEND_CONTACT_MAIL = "SEND_CONTACT_MAIL";
export const SEND_INVESTOR_MAIL = "SEND_INVESTOR_MAIL";